import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { Children } from 'react';
import { Typography } from '../Typography';
export const DataTable = ({ children, noContentMessage }) => (_jsx(_Fragment, { children: Children.count(children) > 0
        ? children
        : noContentMessage && (_jsx(Typography, { variant: "body1", component: "span", children: noContentMessage })) }));
